import i18n from 'i18next';
import icu from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import en from './en';

export const defaultNS = 'pages' as const;
export type TranslationType = typeof en;

const resources = {
  en,
} as const;

i18n
  .use(icu)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    defaultNS,
  })
  .catch((err) => {
    console.log('Failed to set up i18n');
    throw err;
  });

export default i18n;
